import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-main" }
const _hoisted_3 = {
  class: "back-top",
  href: "#home",
  "aria-label": "Nach oben"
}
const _hoisted_4 = { class: "footer-bottom" }

import { ArrowUp } from "lucide-vue-next";
import "@/assets/styles/footer.css";

export default /*@__PURE__*/_defineComponent({
  __name: 'FooterImpressum',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("a", {
        class: "footer-brand",
        href: "#home"
      }, [
        _createElementVNode("span", null, "F"),
        _createElementVNode("div", null, [
          _createElementVNode("strong", null, "FREIRAUM"),
          _createElementVNode("small", null, "Garten · Landschaft · Pflege")
        ])
      ], -1)),
      _cache[1] || (_cache[1] = _createElementVNode("p", null, "Wir bauen Außenräume für Menschen und Unternehmen – mit Haltung, Handwerk und einem Blick fürs Ganze.", -1)),
      _createElementVNode("a", _hoisted_3, [
        _createVNode(_unref(ArrowUp))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[4] || (_cache[4] = _createElementVNode("span", null, "© 2026 Freiraum GaLaBau", -1)),
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, { to: "/impressum" }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("Impressum", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/datenschutz" }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("Datenschutz", -1)
          ]))]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})